import React from 'react'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogContentText from '@material-ui/core/DialogContentText'
import DialogTitle from '@material-ui/core/DialogTitle'
import Button from '@material-ui/core/Button'

/**
 * @param {Object} props
 * @param {boolean} [props.isOpen]
 * @param {Function} props.onClose
 * @param {string} [props.title]
 * @param {string} [props.contentText]
 * @param {Function} [props.onAgree]
 * @param {Function} [props.onDisagree]
 * @param {string} [props.leftButtonLable]
 * @param {string} [props.rightButtonLable]
 * @param {string} props.cypress_id
 */
const ConfirmDialog = ({
  isOpen = false,
  onClose,
  title = 'Confirm Action',
  contentText = '',
  onAgree,
  onDisagree,
  leftButtonLable = 'Disagree',
  rightButtonLable = 'Agree',
  cypress_id,
}) => (
  <Dialog open={isOpen} onClose={onClose} disableEnforceFocus={true}>
    <DialogTitle cypress_id={`${cypress_id}-title`}>{title}</DialogTitle>
    <DialogContent>
      <DialogContentText cypress_id={`${cypress_id}-text`}>
        {contentText}
      </DialogContentText>
    </DialogContent>
    <DialogActions>
      {onDisagree && (
        <Button
          onClick={onDisagree}
          color="primary"
          cypress_id={`${cypress_id}-disagree-button`}
        >
          {leftButtonLable}
        </Button>
      )}
      {onAgree && (
        <Button
          onClick={onAgree}
          color="primary"
          autoFocus
          cypress_id={`${cypress_id}-agree-button`}
        >
          {rightButtonLable}
        </Button>
      )}
    </DialogActions>
  </Dialog>
)
export default ConfirmDialog
